export const initialMainRoute = "dashboard";

export const adminRoutes = {
  users: "utilizatori",
  createUser: "creaza",
  editUser: "editeaza",
  adminUserWebRoles: "roluri-web",
  adminUserMobileRoles: "roluri-mobile",
  administrateReason: "administrare-motive",
  services: "servicii",
  generateBarcode: "genereaza-coduri-de-bare",
  rolesAndNodes: "functii-si-noduri",
  customer_notifications: "notificari-clienti",
};

export const crudRoutes = {
  create: "creaza",
  edit: "edit",
};

export const fleetRoutes = {
  fleet: "fleet",
  features: "features",
  documents: "documents",
  allDocumets: "toate-documentele",
  carsDocuments: "documente-masini",
  assignedCarNode: "masini-asignate-la-noduri",
};

export const expeditionRoutes = {
  activeExpeditions: "expeditii-active",
  routes: "rute",
  nodes: "noduri",
  workingPoints: "locatii-de-livrare",
  organize: "organizeaza",
  clients: "clienti",
  clientsWorkingPoints: "puncte-de-livrare-clienti",
  clientAwbHistory: "istoric-awb-client",
  undeliveredAwb: "awb-nelivrate",
  internodeRoutes: "rute-internod",
  internodeRouteNodes: "noduri-traseu-internod",
  createBin: "creeaza-bin",
  routesOrganizationLocal: "organizare-rute-locale",
  routesOrganizationInternode: "organizare-rute-internod",
  activePackages: "colete-active",
  viewCargoVolume: "vizualizare-volum-marfa",
  binsVolume: "volume-binuri",
  showBins: "vizualizare-binuri",
  scannedPackages: "colete",
  oversizedPackages: "colete-agabaritice",
};

export const transportRoutes = {
  assign: "alocare-ruta",
  assignDriver: "asignare-sofer",
  activeTransports: "transporturi-active",
  copyDriverRoutes: "duplicare-rute-sofer",
  transportHistory: "istoric-transporturi",
};

export const reportsRoutes = {
  searchInvoicesAwb: "cauta-factura-awb",
  cargoNode: "marfa-nod",
  cargoCar: "marfa-masina",
  cargo: "marfa",
  vehicleTemperatureChart: "diagrama-temperatura-autovehicul",
  nodeTemperatureChart: "diagrama-temperatura-nod",
  undeliveredPackagesCentralizer: "centralizator-colete-nelivrate",
  packageHistory: "istoric-colet",
  temperatureAlerts: "alerte-temperatura",
  pickupCargoInternodeRoute: "ridicare-marfa-ruta-internod",
};
